/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Server_Errors_Ratelimited1Inputs */

const he_server_errors_ratelimited1 = /** @type {(inputs: Server_Errors_Ratelimited1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יותר מדי בקשות. נסו שוב מאוחר יותר.`)
};

const en_server_errors_ratelimited1 = /** @type {(inputs: Server_Errors_Ratelimited1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many requests. Please try again later.`)
};

/**
* | output |
* | --- |
* | "Too many requests. Please try again later." |
*
* @param {Server_Errors_Ratelimited1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const server_errors_ratelimited1 = /** @type {((inputs?: Server_Errors_Ratelimited1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Server_Errors_Ratelimited1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_server_errors_ratelimited1(inputs)
	return en_server_errors_ratelimited1(inputs)
});
export { server_errors_ratelimited1 as "server_errors_rateLimited" }